<div id="logo-box" *ngIf="showSimpleLogo">
  <img id="simple-logo">
  <a *ngIf="showSignOutButton" (click)="onSignOut()" class="sign-out-button">Sign out</a>
</div>
